// "Modo tienda": Kontrol abierto desde la app de Google Play (o App Store).
// Las tiendas no permiten mostrar precios ni botones o invitaciones a pagar
// fuera de su sistema de cobro, así que en este modo Kontrol solo muestra el
// estado del plan (sin precios, sin "Quiero este plan", sin "Ver planes").
// En el navegador todo sigue igual.
//
// Se detecta así (y se recuerda en este dispositivo):
//  - la app de la tienda abre Kontrol con ?origen=playstore o ?origen=appstore
//  - en Android, la app instalada desde Play abre con referrer android-app://
const CLAVE = 'kontrol-tienda';

function detectar() {
  try {
    const origen = new URLSearchParams(window.location.search).get('origen');
    if (origen === 'web') { localStorage.removeItem(CLAVE); return false; } // para salir al probar
    if (origen === 'playstore' || origen === 'appstore') {
      localStorage.setItem(CLAVE, origen);
      return true;
    }
    if (document.referrer.startsWith('android-app://')) {
      localStorage.setItem(CLAVE, 'playstore');
      return true;
    }
    return !!localStorage.getItem(CLAVE);
  } catch {
    return false;
  }
}

export const EN_TIENDA = detectar();

// Elige el texto según el modo: normal (navegador) o tienda.
export const segunTienda = (normal, tienda) => (EN_TIENDA ? tienda : normal);
